export default {
  series: {},

  nonSeriesCards: {},

  chapters: {},

  chapterCards: {},
};



// WEBPACK FOOTER //
// ./src/app/publishers/store/state.js